import instance from 'api';
import { BaseApi } from 'baseApi';
import { endpoints } from 'endpoints.config';
import {
  IpWhitelistEntry,
  MfaRequestStatus,
  parseMfaError,
} from 'pages/mfa/models';

export class SchoolMfaApi extends BaseApi {
  public static getMfaRequestStatus = () =>
    BaseApi.send<MfaRequestStatus>(
      () => instance.get(endpoints.manageschool.mfaRequestStatus),
      parseMfaError
    );

  // bConfirmed is the server-side half of the warning popup; the server rejects a request without it.
  public static requestMfaChange = (bMfaRequest: boolean) =>
    BaseApi.send<null>(
      () =>
        instance.post(endpoints.manageschool.requestMfaChange, {
          bMfaRequest,
          bConfirmed: true,
        }),
      parseMfaError
    );

  public static getIpWhitelist = () =>
    BaseApi.send<IpWhitelistEntry[]>(
      () => instance.get(endpoints.manageschool.ipWhitelist),
      parseMfaError
    );

  public static createIpWhitelistEntry = (ipAddress: string) =>
    BaseApi.send<IpWhitelistEntry>(
      () =>
        instance.post(endpoints.manageschool.createIpWhitelistEntry, {
          ipAddress,
        }),
      parseMfaError
    );

  public static deleteIpWhitelistEntry = (
    schoolAccountsIpAddressWhitelistId: number
  ) =>
    BaseApi.send<null>(
      () =>
        instance.post(endpoints.manageschool.deleteIpWhitelistEntry, {
          schoolAccountsIpAddressWhitelistId,
        }),
      parseMfaError
    );
}
